import React from 'react'
import Firebase from 'firebase'

import killPlayer from '../../actions/killPlayer'
import {
  FixedAction,
  Button,
} from '../styles'

const ActiveAction = ({game, players, player}) => {
  if (player && player.alive) {
    return <FixedAction>
        <Button onClick={() => killPlayer({game: game, playerId: Firebase.auth().currentUser.uid})}>I got killed</Button>
      </FixedAction>
  }
  return null
}

export default ActiveAction



// WEBPACK FOOTER //
// ./src/views/game/2_ActiveAction.jsx